<ion-content class="email-forgot-pw-area">
  <form class="form-area" [formGroup]="resetPasswordForm">
    <div>
      <div class="header-bloc">
        <div class="btn-return-b">
          <button class="return-btn" (click)="backto()"></button>
          <h1>{{ 'FORGOT_PW_PAGE.TITLE_EMAIL' | translate}}</h1>
        </div>
        <h3 class="wrap">{{ 'FORGOT_PW_PAGE.SUBTITLE_EMAIL' | translate}}</h3>
        <h2 class="oblig-champ">{{"FORM.VALID.REQUIRED_ALL"|translate}}</h2>
      </div>
      <div class="input-form-box">
        <h1 class="label">{{"FORM.PLACEHOLDER.EMAIL"|translate}}*</h1>
        <div
          class="inputForm border-red"
          [ngClass]="{'border-red':submitted && emailError && f['email'].value}"
        >
          <input
            type="email"
            class="input"
            (input)="removeError()"
            formControlName="email"
            placeholder="{{ 'FORM.PLACEHOLDER.EMAIL' | translate}}"
          />
        </div>
        <div class="error-message" *ngIf="submitted && emailError">
          {{emailErrorMessage}}
        </div>
      </div>
    </div>

    <div class="padding-bloc-btn">

      <app-button
        [innerText]="'BUTTONS.RESET' | translate"
        [disabled]="isLoading"
        [loading]="isLoading"
        (onClick)="submitForm()"
      ></app-button>
    </div>
  </form>
</ion-content>
